import { render, staticRenderFns } from "./SecretAddResult.vue?vue&type=template&id=c630431e&"
import script from "./SecretAddResult.vue?vue&type=script&lang=js&"
export * from "./SecretAddResult.vue?vue&type=script&lang=js&"
import style0 from "./SecretAddResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports